import { defineTokens } from "@chakra-ui/react";

export const semanticTokens = defineTokens({
  colors: {
    success: { value: "colors.green.500" },
    error: { value: "red.500" },
    warning: { value: "yellow.500" },
    info: { value: "blue.500" },
    fail: { value: "red.500" },
    pending: { value: "yellow.500" },

    "primary.bg": { value: "brand.500" },
    "primary.text": { value: "white" },
    "danger.bg": { value: "danger.500" },
    "danger.text": { value: "white" },
    "transaction.success": { value: "{colors.money.500}" },
    "transaction.pending": { value: "{colors.pending.500}" },
    "transaction.failed": { value: "{colors.danger.500}" },
  },
});
